import React from "react";
import moment from "moment-timezone";

import { FULL_ZONE_NAMES } from "../constants/timezone";
import { InfoCircleFilled } from "@ant-design/icons";
import { Input, Popover } from "antd";

function DisabledInputPopover({ placeholder, popover, inputName = "Time Zone" }) {
  if (inputName === "Time Zone") {
    moment.fn.zoneName = function () {
      const abbr = this.zoneAbbr();
      return FULL_ZONE_NAMES[abbr] || abbr;
    };
  }

  const popoverElement = (
    <Popover
      placement="bottom"
      overlayStyle={{ maxWidth: "50%", overflowWrap: "break-word" }}
      content={popover}
    >
      <InfoCircleFilled style={{ fontSize: 18, color: "#2B96FC" }} />
    </Popover>
  );

  return (
    <div>
      <Input
        className="transparent-input-popover"
        addonBefore={inputName}
        key={placeholder}
        addonAfter={popoverElement}
        placeholder={placeholder}
        disabled
      />
    </div>
  );
}

export default DisabledInputPopover;
